import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

@Component({
  name: 'bpc-pos-ticket-tabs',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class PosTicketTabs extends Vue {
  mounted() {
    this.initializeTabModel();
  }

  get posCheckoutOpenTickets() {
    return this.$store.getters['pos/openTickets'];
  }
  get posCurrentTicketId() {
    return this.$store.getters['pos/currentTicketId'];
  }

  @Watch('posCheckoutOpenTickets')
  onChangePosCheckoutOpenTickets() {
    this.initializeTabModel();
  }

  onClick(ticketId) {
    this.$store.commit('pos/storeCurrentTicketId', ticketId);
  }
  onNew() {
    this.$emit('on-new');
  }

  initializeTabModel() {
    if (!this.posCurrentTicketId && this.posCheckoutOpenTickets?.length > 0) {
      this.onClick(this.posCheckoutOpenTickets[0].id);
    }
  }
}
